module.exports = __webpack_public_path__ + "static/img/ic_empty_no_permissions@3x.96f0c880.png";